import { answerValueHasContent } from "./answerValue";

export const cleanStemText = (text, { preserveLineMarkers = false } = {}) => {
  if (!text) return text;
  let cleaned = String(text);
  if (!preserveLineMarkers) {
    cleaned = cleaned.replace(/\{L\d+\}/g, "");
  }
  const mA = cleaned.match(/(?:^|[\n\r]\s*|\s+)(?:\(?a\)|a[).])\s+\S/i);
  const mB = cleaned.match(/(?:^|[\n\r]\s*|\s+)(?:\(?b\)|b[).])\s+\S/i);
  if (mA && mB && mA.index > 30) {
    return cleaned.substring(0, mA.index).trimEnd();
  }
  return cleaned;
};

export const extractSubCore = (text, label) => {
  if (!text || !label) return text;
  const esc = String(label).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const pattern = new RegExp(`(?:^|[\\n\\r])[ \\t]*${esc}[ \\t]*[).][ \\t]*`, "gi");
  let lastMatch = null;
  let match;
  while ((match = pattern.exec(text)) !== null) {
    lastMatch = match;
  }
  if (lastMatch && lastMatch.index > 5) {
    return String(text).substring(lastMatch.index + lastMatch[0].length).trim();
  }
  return text;
};

export const isComprehensionPassage = (question) =>
  question?.type === "grouped" &&
  (question?.passage_type === "comprehension" || (question?.question_text?.length ?? 0) > 400);

export const toSubLabel = (idx, sub) => {
  const paperNumber = sub?.paper_number;
  if (paperNumber != null && Number(paperNumber) !== 0 && String(paperNumber).trim() !== "") {
    return String(paperNumber);
  }
  return `${String.fromCharCode(97 + idx)})`;
};

export const countBlanksInText = (text) => {
  if (!text) return 0;
  const stripped = String(text).replace(/<[^>]+>/g, " ");
  const underscores = (stripped.match(/_{3,}/g) || []).length;
  const brackets = (stripped.match(/\[\s*\]/g) || []).length;
  const boxes = (stripped.match(/□/g) || []).length;
  return underscores + brackets + boxes;
};

export const groupedAnswerHasContent = (value) => answerValueHasContent(value);
